import { inject } from "fw";
import { createFrom } from "fw-model";

import { Manager } from "./manager";
import { AtsOrganizationMappingDetail } from "models/ats-organization-summary";

@inject
export class AtsOrgMappingDetailRepository {
    constructor(private s: Manager) {}

    async getByOrganizationId(organizationId: string) {
        const res = await this.s.get<AtsOrganizationMappingDetail>(`ats-org-mapping-detail/${organizationId}`);
        const result = createFrom(AtsOrganizationMappingDetail, res.body);
        // should not have to do this when createFrom/createFromArray doesn't always initialize a NULL value to an empty instance
        this.sanitizeResult(result);
        return result;
    }

    // should not have to do this when createFrom/createFromArray doesn't always initialize a NULL value to an empty instance
    private sanitizeResult(result: AtsOrganizationMappingDetail) {
        if (!result.Mapping.Id) {
            result.Mapping = null;
            result.AtsOrgTemplateIntegrationResults = [];
            result.CasOrgIntegrationResults = [];
            return;
        }
        result.AtsOrgTemplateIntegrationResults = result.AtsOrgTemplateIntegrationResults.filter((t) => t.Id);
        result.CasOrgIntegrationResults = result.CasOrgIntegrationResults.filter((c) => c.Id);
    }
}
